export default __webpack_public_path__ + "static/media/CircularStd-Medium.e1c58eaa.woff";